import { AsyncStreamConstructorsImpl } from '@rimbu/stream/async-custom';
export const AsyncStream = AsyncStreamConstructorsImpl;
//# sourceMappingURL=async-stream.mjs.map